import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  Long: any,
  Address: any,
  ByteString: any,
  DateTimeOffset: any,
  BigInt: BigInt,
  Date: any,
  DateTime: any,
  Decimal: any,
  Milliseconds: any,
  Seconds: any,
};

export type Action = {
   __typename?: 'Action',
  inspection: Scalars['String'],
  raw: Scalars['String'],
};


export type ActionRawArgs = {
  encode?: Maybe<Scalars['String']>
};



export type Block = {
   __typename?: 'Block',
  difficulty: Scalars['Long'],
  hash: Scalars['ID'],
  index: Scalars['Long'],
  miner: Scalars['Address'],
  nonce: Scalars['ByteString'],
  previousBlock?: Maybe<Block>,
  stateRootHash?: Maybe<Scalars['ByteString']>,
  timestamp: Scalars['DateTimeOffset'],
  totalDifficulty: Scalars['BigInt'],
  transactions: Array<Transaction>,
};

export type BlockQuery = {
   __typename?: 'BlockQuery',
  block?: Maybe<Block>,
  blocks: Array<Block>,
};


export type BlockQueryBlockArgs = {
  hash?: Maybe<Scalars['ID']>,
  index?: Maybe<Scalars['ID']>
};


export type BlockQueryBlocksArgs = {
  desc?: Maybe<Scalars['Boolean']>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>,
  excludeEmptyTxs?: Maybe<Scalars['Boolean']>,
  miner?: Maybe<Scalars['Address']>
};


export type ChainQuery = {
   __typename?: 'ChainQuery',
  blockQuery?: Maybe<BlockQuery>,
  transactionQuery?: Maybe<TransactionQuery>,
};







export type Query = {
   __typename?: 'Query',
  chainQuery: ChainQuery,
};


export type Transaction = {
   __typename?: 'Transaction',
  actions: Array<Action>,
  id: Scalars['ID'],
  nonce: Scalars['Int'],
  publicKey: Scalars['ByteString'],
  signature: Scalars['ByteString'],
  signer: Scalars['Address'],
  timestamp: Scalars['DateTimeOffset'],
  updatedAddresses: Array<Scalars['Address']>,
};

export type TransactionQuery = {
   __typename?: 'TransactionQuery',
  transaction?: Maybe<Transaction>,
  transactions: Array<Transaction>,
};


export type TransactionQueryTransactionArgs = {
  id?: Maybe<Scalars['ID']>
};


export type TransactionQueryTransactionsArgs = {
  signer?: Maybe<Scalars['Address']>,
  involvedAddress?: Maybe<Scalars['Address']>,
  desc?: Maybe<Scalars['Boolean']>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};
export type BlockCommonFragment = ({ __typename?: 'Block' } & Pick<Block, 'hash' | 'index' | 'difficulty' | 'timestamp' | 'totalDifficulty'>);

export type TransactionCommonFragment = ({ __typename?: 'Transaction' } & Pick<Transaction, 'id' | 'nonce' | 'publicKey' | 'signature' | 'signer' | 'timestamp' | 'updatedAddresses'>);

export type BlockListQueryVariables = {
  offset: Scalars['Int'],
  limit: Scalars['Int'],
  excludeEmptyTxs: Scalars['Boolean'],
  miner?: Maybe<Scalars['Address']>
};


export type BlockListQuery = ({ __typename?: 'Query' } & { chainQuery: ({ __typename?: 'ChainQuery' } & { blockQuery: Maybe<({ __typename?: 'BlockQuery' } & { blocks: Array<({ __typename?: 'Block' } & Pick<Block, 'miner'> & { previousBlock: Maybe<({ __typename?: 'Block' } & Pick<Block, 'timestamp'>)>, transactions: Array<({ __typename?: 'Transaction' } & Pick<Transaction, 'id'>)> } & BlockCommonFragment)> })> }) });

export type BlockByHashQueryVariables = {
  hash: Scalars['ID']
};


export type BlockByHashQuery = ({ __typename?: 'Query' } & { chainQuery: ({ __typename?: 'ChainQuery' } & { blockQuery: Maybe<({ __typename?: 'BlockQuery' } & { block: Maybe<({ __typename?: 'Block' } & Pick<Block, 'miner' | 'nonce' | 'stateRootHash'> & { previousBlock: Maybe<({ __typename?: 'Block' } & Pick<Block, 'hash'>)>, transactions: Array<({ __typename?: 'Transaction' } & TransactionCommonFragment)> } & BlockCommonFragment)> })> }) });

export type BlockByIndexQueryVariables = {
  index: Scalars['ID']
};


export type BlockByIndexQuery = ({ __typename?: 'Query' } & { chainQuery: ({ __typename?: 'ChainQuery' } & { blockQuery: Maybe<({ __typename?: 'BlockQuery' } & { block: Maybe<({ __typename?: 'Block' } & Pick<Block, 'hash'>)> })> }) });

export type TransactionListQueryVariables = {
  signer?: Maybe<Scalars['Address']>,
  involvedAddress?: Maybe<Scalars['Address']>,
  desc: Scalars['Boolean'],
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type TransactionListQuery = ({ __typename?: 'Query' } & { chainQuery: ({ __typename?: 'ChainQuery' } & { transactionQuery: Maybe<({ __typename?: 'TransactionQuery' } & { transactions: Array<({ __typename?: 'Transaction' } & TransactionCommonFragment)> })> }) });

export type TransactionByIdQueryVariables = {
  id?: Maybe<Scalars['ID']>
};


export type TransactionByIdQuery = ({ __typename?: 'Query' } & { chainQuery: ({ __typename?: 'ChainQuery' } & { transactionQuery: Maybe<({ __typename?: 'TransactionQuery' } & { transaction: Maybe<({ __typename?: 'Transaction' } & { actions: Array<({ __typename?: 'Action' } & Pick<Action, 'raw'>)> } & TransactionCommonFragment)> })> }) });

export type TransactionsByAccountQueryVariables = {
  involvedAddress: Scalars['Address'],
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type TransactionsByAccountQuery = ({ __typename?: 'Query' } & { chainQuery: ({ __typename?: 'ChainQuery' } & { transactionQuery: Maybe<({ __typename?: 'TransactionQuery' } & { involvedTransactions: Array<({ __typename?: 'Transaction' } & TransactionCommonFragment)>, signedTransactions: Array<({ __typename?: 'Transaction' } & TransactionCommonFragment)> })> }) });
export const BlockCommonFragmentDoc = gql`
    fragment BlockCommon on Block {
  hash
  index
  difficulty
  timestamp
  totalDifficulty
}
    `;
export const TransactionCommonFragmentDoc = gql`
    fragment TransactionCommon on Transaction {
  id
  nonce
  publicKey
  signature
  signer
  timestamp
  updatedAddresses
}
    `;
export const BlockListDocument = gql`
    query BlockList($offset: Int!, $limit: Int!, $excludeEmptyTxs: Boolean!, $miner: Address) {
  chainQuery {
    blockQuery {
      blocks(desc: true, offset: $offset, limit: $limit, excludeEmptyTxs: $excludeEmptyTxs, miner: $miner) {
        ...BlockCommon
        miner
        previousBlock {
          timestamp
        }
        transactions {
          id
        }
      }
    }
  }
}
    ${BlockCommonFragmentDoc}`;
export type BlockListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BlockListQuery, BlockListQueryVariables>, 'query'> & ({ variables: BlockListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BlockListComponent = (props: BlockListComponentProps) => (
      <ApolloReactComponents.Query<BlockListQuery, BlockListQueryVariables> query={BlockListDocument} {...props} />
    );
    
export type BlockListProps<TChildProps = {}> = ApolloReactHoc.DataProps<BlockListQuery, BlockListQueryVariables> & TChildProps;
export function withBlockList<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BlockListQuery,
  BlockListQueryVariables,
  BlockListProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, BlockListQuery, BlockListQueryVariables, BlockListProps<TChildProps>>(BlockListDocument, {
      alias: 'withBlockList',
      ...operationOptions
    });
};
export type BlockListQueryResult = ApolloReactCommon.QueryResult<BlockListQuery, BlockListQueryVariables>;
export const BlockByHashDocument = gql`
    query BlockByHash($hash: ID!) {
  chainQuery {
    blockQuery {
      block(hash: $hash) {
        ...BlockCommon
        miner
        nonce
        stateRootHash
        previousBlock {
          hash
        }
        transactions {
          ...TransactionCommon
        }
      }
    }
  }
}
    ${BlockCommonFragmentDoc}
${TransactionCommonFragmentDoc}`;
export type BlockByHashComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BlockByHashQuery, BlockByHashQueryVariables>, 'query'> & ({ variables: BlockByHashQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BlockByHashComponent = (props: BlockByHashComponentProps) => (
      <ApolloReactComponents.Query<BlockByHashQuery, BlockByHashQueryVariables> query={BlockByHashDocument} {...props} />
    );
    
export type BlockByHashProps<TChildProps = {}> = ApolloReactHoc.DataProps<BlockByHashQuery, BlockByHashQueryVariables> & TChildProps;
export function withBlockByHash<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BlockByHashQuery,
  BlockByHashQueryVariables,
  BlockByHashProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, BlockByHashQuery, BlockByHashQueryVariables, BlockByHashProps<TChildProps>>(BlockByHashDocument, {
      alias: 'withBlockByHash',
      ...operationOptions
    });
};
export type BlockByHashQueryResult = ApolloReactCommon.QueryResult<BlockByHashQuery, BlockByHashQueryVariables>;
export const BlockByIndexDocument = gql`
    query BlockByIndex($index: ID!) {
  chainQuery {
    blockQuery {
      block(index: $index) {
        hash
      }
    }
  }
}
    `;
export type BlockByIndexComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BlockByIndexQuery, BlockByIndexQueryVariables>, 'query'> & ({ variables: BlockByIndexQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BlockByIndexComponent = (props: BlockByIndexComponentProps) => (
      <ApolloReactComponents.Query<BlockByIndexQuery, BlockByIndexQueryVariables> query={BlockByIndexDocument} {...props} />
    );
    
export type BlockByIndexProps<TChildProps = {}> = ApolloReactHoc.DataProps<BlockByIndexQuery, BlockByIndexQueryVariables> & TChildProps;
export function withBlockByIndex<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BlockByIndexQuery,
  BlockByIndexQueryVariables,
  BlockByIndexProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, BlockByIndexQuery, BlockByIndexQueryVariables, BlockByIndexProps<TChildProps>>(BlockByIndexDocument, {
      alias: 'withBlockByIndex',
      ...operationOptions
    });
};
export type BlockByIndexQueryResult = ApolloReactCommon.QueryResult<BlockByIndexQuery, BlockByIndexQueryVariables>;
export const TransactionListDocument = gql`
    query TransactionList($signer: Address, $involvedAddress: Address, $desc: Boolean!, $offset: Int!, $limit: Int!) {
  chainQuery {
    transactionQuery {
      transactions(signer: $signer, involvedAddress: $involvedAddress, desc: $desc, offset: $offset, limit: $limit) {
        ...TransactionCommon
      }
    }
  }
}
    ${TransactionCommonFragmentDoc}`;
export type TransactionListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TransactionListQuery, TransactionListQueryVariables>, 'query'> & ({ variables: TransactionListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TransactionListComponent = (props: TransactionListComponentProps) => (
      <ApolloReactComponents.Query<TransactionListQuery, TransactionListQueryVariables> query={TransactionListDocument} {...props} />
    );
    
export type TransactionListProps<TChildProps = {}> = ApolloReactHoc.DataProps<TransactionListQuery, TransactionListQueryVariables> & TChildProps;
export function withTransactionList<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TransactionListQuery,
  TransactionListQueryVariables,
  TransactionListProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, TransactionListQuery, TransactionListQueryVariables, TransactionListProps<TChildProps>>(TransactionListDocument, {
      alias: 'withTransactionList',
      ...operationOptions
    });
};
export type TransactionListQueryResult = ApolloReactCommon.QueryResult<TransactionListQuery, TransactionListQueryVariables>;
export const TransactionByIdDocument = gql`
    query TransactionById($id: ID) {
  chainQuery {
    transactionQuery {
      transaction(id: $id) {
        ...TransactionCommon
        actions {
          raw(encode: "base64")
        }
      }
    }
  }
}
    ${TransactionCommonFragmentDoc}`;
export type TransactionByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TransactionByIdQuery, TransactionByIdQueryVariables>, 'query'>;

    export const TransactionByIdComponent = (props: TransactionByIdComponentProps) => (
      <ApolloReactComponents.Query<TransactionByIdQuery, TransactionByIdQueryVariables> query={TransactionByIdDocument} {...props} />
    );
    
export type TransactionByIdProps<TChildProps = {}> = ApolloReactHoc.DataProps<TransactionByIdQuery, TransactionByIdQueryVariables> & TChildProps;
export function withTransactionById<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TransactionByIdQuery,
  TransactionByIdQueryVariables,
  TransactionByIdProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, TransactionByIdQuery, TransactionByIdQueryVariables, TransactionByIdProps<TChildProps>>(TransactionByIdDocument, {
      alias: 'withTransactionById',
      ...operationOptions
    });
};
export type TransactionByIdQueryResult = ApolloReactCommon.QueryResult<TransactionByIdQuery, TransactionByIdQueryVariables>;
export const TransactionsByAccountDocument = gql`
    query TransactionsByAccount($involvedAddress: Address!, $offset: Int, $limit: Int) {
  chainQuery {
    transactionQuery {
      involvedTransactions: transactions(involvedAddress: $involvedAddress, desc: true, offset: $offset, limit: $limit) {
        ...TransactionCommon
      }
      signedTransactions: transactions(signer: $involvedAddress, desc: true, offset: $offset, limit: $limit) {
        ...TransactionCommon
      }
    }
  }
}
    ${TransactionCommonFragmentDoc}`;
export type TransactionsByAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TransactionsByAccountQuery, TransactionsByAccountQueryVariables>, 'query'> & ({ variables: TransactionsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TransactionsByAccountComponent = (props: TransactionsByAccountComponentProps) => (
      <ApolloReactComponents.Query<TransactionsByAccountQuery, TransactionsByAccountQueryVariables> query={TransactionsByAccountDocument} {...props} />
    );
    
export type TransactionsByAccountProps<TChildProps = {}> = ApolloReactHoc.DataProps<TransactionsByAccountQuery, TransactionsByAccountQueryVariables> & TChildProps;
export function withTransactionsByAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TransactionsByAccountQuery,
  TransactionsByAccountQueryVariables,
  TransactionsByAccountProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, TransactionsByAccountQuery, TransactionsByAccountQueryVariables, TransactionsByAccountProps<TChildProps>>(TransactionsByAccountDocument, {
      alias: 'withTransactionsByAccount',
      ...operationOptions
    });
};
export type TransactionsByAccountQueryResult = ApolloReactCommon.QueryResult<TransactionsByAccountQuery, TransactionsByAccountQueryVariables>;